var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gallery",
    transform: "translate(-143 14.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(143 -14.025)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 13.825,
    cy: 13.825,
    rx: 13.825,
    ry: 13.825,
    transform: "translate(2.35 1.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cancel-button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M15,0A15,15,0,1,0,30,15,15.044,15.044,0,0,0,15,0Zm7.5,20.4-2.1,2.1L15,17.1,9.6,22.5,7.5,20.4,12.9,15,7.5,9.6,9.6,7.5,15,12.9l5.4-5.4,2.1,2.1L17.1,15Z",
    fill: "#041543"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.4039923d36d2910e4ea07fb47b394ca6.svg";
export { ForwardRef as ReactComponent };